import { FormikHelpers as FormikActions } from 'formik';
import * as React from 'react';

import { TwsAdminApi } from '@weddingspot/ws-api-client';
import { TwsAdmin, AvailabilityFormData, SeasonAvailabilityType } from '../../components/venue-management/types';
import { toFormikError, WrappedWsApiError, WrappedWsApiValidationError } from '../../utils/formik/error';
import { Availability } from '../../components/venue-management/Availability';
import { defaultAvailabilityFormData } from '../../components/venue-management/constants';
import AppLogger from '../../utils/logging';
const logger = AppLogger.createLogger();

interface OwnProps {
    currentVenue: TwsAdmin.AvailableVenue;

    // Notify parent that an initialization error occurred
    onInitError: () => void;

    // Notify parent that a form error occurred
    onFormError: () => void;

    // Notify parent that form was successfully submitted
    onFormSuccess: () => void;

    // Notify the partne that the form was touched
    setTouched: (touched: boolean) => void;
}

interface OwnState {
    choicesLoaded: boolean | null;
    choices: TwsAdmin.AvailabilityFormChoices | null;
    initialValuesLoaded: boolean | null;
    initialValues: AvailabilityFormData | null;
}

export default class AvailabilityContainer extends React.Component<OwnProps, OwnState> {
    constructor(props: OwnProps) {
        super(props);

        this.state = {
            choicesLoaded: null,
            choices: null,
            initialValuesLoaded: null,
            initialValues: null,
        };

        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        // Fetch availability choices
        const venueId = this.props.currentVenue.venue_id;
        TwsAdminApi.getAvailabilityChoices()
            .then((choices) => {
                this.setState({
                    choices: choices,
                    choicesLoaded: true,
                });

                TwsAdminApi.getAvailabilityValues(venueId)
                    .then((values) => {
                        this.setState({
                            initialValues: {
                                ...values,
                                season_availability: `${values.season_availability}` as SeasonAvailabilityType,
                                extra_hours_charge_type: values.extra_hours_charge_type,
                            },
                            initialValuesLoaded: true,
                        });
                    })
                    .catch(() => {
                        this.setState({ initialValuesLoaded: false });
                    });
            })
            .catch(() => {
                this.setState({
                    choicesLoaded: false,
                    initialValuesLoaded: false,
                });
            });
    }

    render() {
        const { currentVenue } = this.props;

        return (
            <div>
                <Availability
                    currentVenue={currentVenue}
                    choicesLoaded={this.state.choicesLoaded}
                    choices={this.state.choices}
                    valuesLoaded={this.state.initialValuesLoaded}
                    initialValues={this.state.initialValuesLoaded ? this.state.initialValues : defaultAvailabilityFormData}
                    onSubmit={this.onSubmit}
                    onInitError={() => alert('onInitError')}
                    onFormError={() => alert('onFormError')}
                    onFormSuccess={() => alert('onFormSuccess')}
                    setTouched={this.props.setTouched}
                />
            </div>
        );
    }

    private onSubmit(data: AvailabilityFormData, actions: FormikActions<AvailabilityFormData>) {
        logger.info(JSON.stringify(data));

        actions.setSubmitting(true);
        actions.setStatus(undefined);

        // Transform form data to API payload
        const payload: TwsAdmin.AvailabilityData = {
            ...data,
            season_availability: parseInt(data.season_availability, 10),
        };

        return TwsAdminApi.updateAvailabilityValues(this.props.currentVenue.venue_id, payload)
            .then(() => {
                actions.setTouched({});
                this.props.onFormSuccess();
            })
            .catch((err: WrappedWsApiError<TwsAdmin.AvailabilityData>) => {
                // Handle proper API responses
                if (!!err.detail && !!err.status) {
                    if (err.status === 400) {
                        const validationError: WrappedWsApiValidationError<TwsAdmin.GeneralInfoWriteData> = err;

                        let transformed = toFormikError<TwsAdmin.AvailabilityData>(validationError);

                        actions.setErrors(transformed);
                    } else {
                        actions.setStatus('An unknown error occurred while attemping' + ' to save values. Please contact support');
                    }
                } else {
                    actions.setStatus('An unknown error occurred while attemping' + ' to save values. Please contact support');
                }

                this.props.onFormError();
            })
            .then(() => {
                actions.setSubmitting(false);
            });
    }
}
